//Mainnet
const gStableManagerContractAddress = "TNcjtBJuqUeGU7QBDwHD7moif7PMtT5au1";
const SwapUSDDContractAddress = "TWe35BM6sFH4fAgabxaCmodJfjXi6yj6fZ";
const VaultUSDDContractAddress = "TQwtTaFjBK7MTKis5xqVdsk56VMinZGLVQ";
const MarketContractAddress = "TX7kybeP6UwTBRHLNPYmswFESHfyjm9bAS";

// const SwapGStableContractAddress = "TB2ZNssD5WvGa2HSLHiYwe4xbsqW7ywcHN";

export {gStableManagerContractAddress, SwapUSDDContractAddress, VaultUSDDContractAddress, MarketContractAddress}